import { Union, Record } from "../../fable_modules/fable-library-js.4.19.3/Types.js";
import { StudyViewModel_$reflection } from "../../RAWMap.Models/View/Study.js";
import { PatientViewModel_$reflection } from "../../RAWMap.Models/View/Patient.js";
import { InstitutionViewModel_$reflection } from "../../RAWMap.Models/View/Institution.js";
import { AnalysisViewModel_$reflection } from "../../RAWMap.Models/View/Analysis.js";
import { DeviceOptionsViewModel_$reflection } from "../../RAWMap.Models/View/DeviceOptions.js";
import { StentPlanScreenshots_$reflection } from "../../Visualization/StentPlanning/StentPlanningBindings.js";
import { CompositeScreenshots_$reflection } from "../../Visualization/StentPlanning/StentPlanningTypes.js";
import { PatientInformationViewModel_$reflection } from "../../RAWMap.Models/View/PatientInformation.js";
import { class_type, union_type, list_type, array_type, record_type, option_type } from "../../fable_modules/fable-library-js.4.19.3/Reflection.js";
import { CustomStentReportViewModel_$reflection } from "../../RAWMap.Models/View/CustomStentReport.js";
import { FileManagementUpdateArgs_$reflection } from "../../FileManagement/FileManagementTypes.js";
import { UserRole_$reflection } from "../../RAWMap.Models/Security.js";
import { FSharpChoice$2 } from "../../fable_modules/fable-library-js.4.19.3/Choice.js";
import { OutboundMsg_$reflection as OutboundMsg_$reflection_1, InboundMsg_$reflection as InboundMsg_$reflection_1, LocalMsg_$reflection as LocalMsg_$reflection_1, ModelScreenshot_$reflection } from "../../Visualization/Screenshot/ScreenshotTypes.js";
import { PromptType_$reflection, OutboundMsg_$reflection as OutboundMsg_$reflection_2, InboundMsg_$reflection as InboundMsg_$reflection_2, LocalMsg_$reflection as LocalMsg_$reflection_2, ModelReportPrompt_$reflection } from "./ReportPrompt/ReportPromptTypes.js";
import { ChildAbsentStrategy$1_$reflection, DefaultActions_ChildModel$2_$reflection } from "../../Common/Terminate.js";
import { ErrorMessage_$reflection } from "../../RAWMap.Models/ErrorMessage.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.19.3/Result.js";
import { Msg$3_$reflection } from "../../Common/InboundOutbound.js";
import { ChainedChildMsg$2_$reflection } from "../../Common/ElmishDebugger/ChainedChildMsg.js";

export class CustomStentReportInitArgs extends Record {
    constructor(selectedStudy, selectedPatient, patientInstitution, studyAnalysis, devices, stentPlanScreenshots, compositeScreenshots, maybePatientInfo) {
        super();
        this.selectedStudy = selectedStudy;
        this.selectedPatient = selectedPatient;
        this.patientInstitution = patientInstitution;
        this.studyAnalysis = studyAnalysis;
        this.devices = devices;
        this.stentPlanScreenshots = stentPlanScreenshots;
        this.compositeScreenshots = compositeScreenshots;
        this.maybePatientInfo = maybePatientInfo;
    }
}

export function CustomStentReportInitArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.Types.CustomStentReportInitArgs", [], CustomStentReportInitArgs, () => [["selectedStudy", StudyViewModel_$reflection()], ["selectedPatient", PatientViewModel_$reflection()], ["patientInstitution", InstitutionViewModel_$reflection()], ["studyAnalysis", AnalysisViewModel_$reflection()], ["devices", DeviceOptionsViewModel_$reflection()], ["stentPlanScreenshots", StentPlanScreenshots_$reflection()], ["compositeScreenshots", CompositeScreenshots_$reflection()], ["maybePatientInfo", option_type(PatientInformationViewModel_$reflection())]]);
}

export class CustomStentReportUpdateArgs extends Record {
    constructor(customReports, fileArgs, userRoles) {
        super();
        this.customReports = customReports;
        this.fileArgs = fileArgs;
        this.userRoles = userRoles;
    }
}

export function CustomStentReportUpdateArgs_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.Types.CustomStentReportUpdateArgs", [], CustomStentReportUpdateArgs, () => [["customReports", array_type(CustomStentReportViewModel_$reflection())], ["fileArgs", FileManagementUpdateArgs_$reflection()], ["userRoles", list_type(UserRole_$reflection())]]);
}

export class Operation extends Union {
    constructor() {
        super();
        this.tag = 0;
        this.fields = [];
    }
    cases() {
        return ["GeneratingReportPdf"];
    }
}

export function Operation_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Types.Operation", [], Operation, () => [[]]);
}

export function Operation_viewDisplay_Z166E462(operation) {
    return "Generating Report";
}

export class Mode extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Review", "RunningOperation"];
    }
}

export function Mode_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Types.Mode", [], Mode, () => [[], [["Item", Operation_$reflection()]]]);
}

export function ModeModule_$007CDisableButtons$007CEnableButtons$007C(mode) {
    if (mode.tag === 0) {
        return new FSharpChoice$2(1, [undefined]);
    }
    else {
        return new FSharpChoice$2(0, [Operation_viewDisplay_Z166E462(mode.fields[0])]);
    }
}

export function ModeModule_$007CSpinner$007CNoSpinner$007C(mode) {
    if (mode.tag === 0) {
        return new FSharpChoice$2(1, [undefined]);
    }
    else {
        return new FSharpChoice$2(0, [Operation_viewDisplay_Z166E462(mode.fields[0])]);
    }
}

export class ModelCustomStentReport extends Record {
    constructor(SelectedStudy, SelectedPatient, PatientInstitution, StudyAnalysis, MaybePreviousStudy, ScreenshotModel, Mode, Devices, StentPlanScreenshots, CompositeScreenshots, MaybePatientInfo, PromptComponent) {
        super();
        this.SelectedStudy = SelectedStudy;
        this.SelectedPatient = SelectedPatient;
        this.PatientInstitution = PatientInstitution;
        this.StudyAnalysis = StudyAnalysis;
        this.MaybePreviousStudy = MaybePreviousStudy;
        this.ScreenshotModel = ScreenshotModel;
        this.Mode = Mode;
        this.Devices = Devices;
        this.StentPlanScreenshots = StentPlanScreenshots;
        this.CompositeScreenshots = CompositeScreenshots;
        this.MaybePatientInfo = MaybePatientInfo;
        this.PromptComponent = PromptComponent;
    }
}

export function ModelCustomStentReport_$reflection() {
    return record_type("RAWMap.Client.Study.CustomStentReport.Types.ModelCustomStentReport", [], ModelCustomStentReport, () => [["SelectedStudy", StudyViewModel_$reflection()], ["SelectedPatient", PatientViewModel_$reflection()], ["PatientInstitution", InstitutionViewModel_$reflection()], ["StudyAnalysis", AnalysisViewModel_$reflection()], ["MaybePreviousStudy", option_type(StudyViewModel_$reflection())], ["ScreenshotModel", ModelScreenshot_$reflection()], ["Mode", Mode_$reflection()], ["Devices", DeviceOptionsViewModel_$reflection()], ["StentPlanScreenshots", StentPlanScreenshots_$reflection()], ["CompositeScreenshots", CompositeScreenshots_$reflection()], ["MaybePatientInfo", option_type(PatientInformationViewModel_$reflection())], ["PromptComponent", DefaultActions_ChildModel$2_$reflection(ModelReportPrompt_$reflection(), ModelCustomStentReport_$reflection())]]);
}

export class LocalMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["ExnErrorMsg", "TryGetPreviousStudy", "TryGetPreviousStudyResult", "ScreenshotMsg", "ReportPromptMsg", "TerminatePromptComponent", "CreatePromptComponent"];
    }
}

export function LocalMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Types.LocalMsg", [], LocalMsg, () => [[["Item", class_type("System.Exception")]], [], [["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [list_type(StudyViewModel_$reflection()), ErrorMessage_$reflection()], FSharpResult$2, () => [[["ResultValue", list_type(StudyViewModel_$reflection())]], [["ErrorValue", ErrorMessage_$reflection()]]])]], [["Item", Msg$3_$reflection(LocalMsg_$reflection_1(), InboundMsg_$reflection_1(), OutboundMsg_$reflection_1())]], [["Item", ChainedChildMsg$2_$reflection(Msg$3_$reflection(LocalMsg_$reflection_2(), InboundMsg_$reflection_2(), OutboundMsg_$reflection_2()), ChildAbsentStrategy$1_$reflection(ModelCustomStentReport_$reflection()))]], [], [["Item", PromptType_$reflection()]]]);
}

export class InboundMsg {
    constructor() {
    }
}

export function InboundMsg_$reflection() {
    return class_type("RAWMap.Client.Study.CustomStentReport.Types.InboundMsg", undefined, InboundMsg);
}

export class OutboundMsg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateCustomReport", "CancelCustomReport"];
    }
}

export function OutboundMsg_$reflection() {
    return union_type("RAWMap.Client.Study.CustomStentReport.Types.OutboundMsg", [], OutboundMsg, () => [[["Item", CustomStentReportViewModel_$reflection()]], []]);
}

